import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function VerifyMFA() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('No token provided.');
      return;
    }

    fetch('/api/verify-mfa', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token })
    })
      .then(res => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(() => {
        // on success go to admin
        navigate('/admin', { replace: true });
      })
      .catch(() => {
        setError('Invalid or expired link. Please log in again.');
      });
  }, [searchParams, navigate]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      {error ? <p style={{ color: 'red' }}>{error}</p> : <p>Verifying MFA…</p>}
    </div>
  );
}
